function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1"
}, /*#__PURE__*/React.createElement("title", null, "VF_"), /*#__PURE__*/React.createElement("path", {
  d: "M255.1 212.6V70.8h-28.4v141.8h-28.3V99.4h-28.3v113.2h-28.4v-85.1h-28.3v85.1H85.1v-56.5H56.7v56.5H28.3V42.5H0v198.4h283.5v-28.3z",
  id: "Layer_1"
}))));